import styled from 'styled-components';

const StyledLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  height: 60vh;
`;

export default StyledLoaderContainer;
